import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/iconButtonStyle.js';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IIconButtonProps {
	label?: string;
	children: string | React.ReactElement;
	disabled?: boolean;
	className?: string;
	size?: 'lg' | 'sm';
	onClick?: () => void;
}

const IconButton = React.forwardRef(
	({ children, disabled, label, className, size = 'lg', ...rest }: IIconButtonProps, ref) => {
		const classes = useStyles();
		const containerClasses = classNames({
			[classes.container]: true,
		});

		const buttonClasses = classNames({
			[className ? className : '']: true,
			[classes.button]: true,
		});

		const labelClasses = classNames({
			[classes.label]: true,
			[classes.disabled]: disabled,
		});

		return (
			<div className={containerClasses}>
				<Button
					disabled={disabled}
					{...rest}
					justIcon
					round
					size={size}
					color="primary-light"
					ref={ref}
					className={buttonClasses}
				>
					{children}
				</Button>
				{!!label && <span className={labelClasses}>{label}</span>}
			</div>
		);
	}
);

export default IconButton;
